import React from 'react';
import PropTypes from 'prop-types';
import { component } from '@signal/prop-types';
import renderIf from '@signal/utils/renderIf';
import { Wrapper, Grid, Title, Description } from './styles';
export function EmptyScreen(_ref) {
  var Icon = _ref.Icon,
      title = _ref.title,
      className = _ref.className,
      style = _ref.style,
      description = _ref.description;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Icon, {
    width: 60,
    height: 60,
    alt: title
  }), /*#__PURE__*/React.createElement(Title, null, title), renderIf(description, /*#__PURE__*/React.createElement(Description, null, description))));
}
EmptyScreen.propTypes = {
  Icon: component.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string
};
export default EmptyScreen;